import axiosTokenInstance from 'services/api/backoffice';
import { GET_CAMPAIGN_CHANNEL, GET_CAMPAIGN_CHANNEL_ERROR } from '_models/redux/types';

// Action function
export const getCampaignChannelAction = (params) => async (dispatch) => {
  const { from_time, to_time, lead_status_id, landing_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `/api/reports/campaing-channel?from_time=${from_time}&to_time=${to_time}&lead_status_id=${lead_status_id}&landing_id=${landing_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'get',
      payload: data || {},
      status: status || {},
      type: GET_CAMPAIGN_CHANNEL,
    });
  } catch (e) {
    dispatch({
      method: 'get',
      payload: e || {},
      type: GET_CAMPAIGN_CHANNEL_ERROR,
    });
  }
};
